import { Sidebar } from '@/components/sidebar'
import { SignOutButton } from '@/components/signout-button'
import { requireAdminPage } from '@/lib/admin-auth'

export const dynamic = 'force-dynamic'

export default async function DashboardLayout({ children }: { children: React.ReactNode }) {
  const current = await requireAdminPage()

  return (
    <div className="app-shell grid-two">
      <div>
        <Sidebar />
        <div className="sidebar-footer">
          <div className="card">
            <div className="muted">Connecté</div>
            <strong>{current.user.email ?? current.user.id}</strong>
            <div className="footer-note">Rôle : {current.admin.role}</div>
          </div>
          <SignOutButton />
        </div>
      </div>

      <main className="main">{children}</main>
    </div>
  )
}
